import { motion, useReducedMotion } from "framer-motion";

// Decorative segmented ring echoing the Green Circle Group logo. Built from many
// short arcs so it reads as the brand's dashed circle. Purely decorative.
export default function GrowthRing({
  size = 420,
  className = "",
  segments = 34,
  colorFrom = "#8DFE3F",
  colorTo = "#2CD59C",
  spin = true,
  duration = 60,
}) {
  const reduce = useReducedMotion();
  const cx = size / 2;
  const cy = size / 2;
  const r = size / 2 - 14;
  const dots = Array.from({ length: segments });

  const spinAnim =
    spin && !reduce
      ? { rotate: 360 }
      : {};
  const transition =
    spin && !reduce
      ? { repeat: Infinity, ease: "linear", duration }
      : {};

  return (
    <motion.svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      animate={spinAnim}
      transition={transition}
      style={{ transformOrigin: "center" }}
    >
      <defs>
        <linearGradient id="ringGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor={colorFrom} />
          <stop offset="100%" stopColor={colorTo} />
        </linearGradient>
      </defs>
      {dots.map((_, i) => {
        const angle = (i / segments) * Math.PI * 2;
        const x1 = cx + Math.cos(angle) * (r - 8);
        const y1 = cy + Math.sin(angle) * (r - 8);
        const x2 = cx + Math.cos(angle) * (r + 8);
        const y2 = cy + Math.sin(angle) * (r + 8);
        const t = i / segments;
        return (
          <line
            key={i}
            x1={x1}
            y1={y1}
            x2={x2}
            y2={y2}
            stroke="url(#ringGrad)"
            strokeWidth={6}
            strokeLinecap="round"
            opacity={0.35 + 0.65 * (1 - Math.abs(0.5 - t) * 2)}
          />
        );
      })}
    </motion.svg>
  );
}
